import React, { useState } from 'react';
import { useAlert } from 'react-alert';
import { useTranslation } from 'react-i18next';
import { createProduct } from 'app/routes/Dashboard/actions/products';
import { getError, getUserLocale } from 'utils/appHelpers';
import { toggleProjectFromLikiee } from 'app/routes/Dashboard/actions/projects';
import ManageModal from '../modals/ManageModal';
import ProjectModal from 'app/routes/Dashboard/routes/Home/components/ProjectModal';
import Input from '../Input';
import ProjectCheckboxSelection from './ProjectCheckboxSelection';

const AddProductModal = ({ onClose, customProjectID }) => {
  const { t } = useTranslation();
  const alert = useAlert();
  const [projectIDs, setProjectIds] = useState(customProjectID ? [customProjectID] : []);
  const [fetching, setFetching] = useState(false);
  const [showProjectCreation, setShowProjectCreation] = useState(false);
  const [url, setUrl] = useState('');
  const [error, setError] = useState('');

  const onFormSubmit = async () => {
    try {
      setFetching(true);
      setError(''); // Clear previous errors
      const locale = getUserLocale();
      const product = await createProduct({ url, locale });
      await toggleProjectFromLikiee(product.id, projectIDs);
      onClose();
      setFetching(false);
      alert.success(t('msg_success_product_create'));
    } catch (err) {
      const errorMessage = getError(err);
      setError(errorMessage);
      alert.error(errorMessage);
      setFetching(false);
    }
  };

  const onCloseProjectCreation = () => {
    setShowProjectCreation(false);
  };

  if (showProjectCreation) {
    return <ProjectModal onClose={onCloseProjectCreation} />;
  }

  return (
    <ManageModal
      title={t('add_product_title')}
      sumbitButton={t('btn_save')}
      onCloseModal={onClose}
      onSubmit={onFormSubmit}
      className='alert-modal'
      isButtonDisabled={fetching}
      errorMessage={error}
    >
      <div className='col-12 p-0'>
        <Input
          type='text'
          name='name'
          onChange={({ target }) => setUrl(target.value)}
          value={url}
          label={t('label_insert_url')}
          placeholder=''
          className='mb-12 mb-md-15'
          required
        />
      </div>
      <div className='row pb-5'>
        <ProjectCheckboxSelection
          setShowProjectCreation={setShowProjectCreation}
          projectIDs={projectIDs}
          setProjectIds={setProjectIds}
        />
      </div>
    </ManageModal>
  );
};

export default AddProductModal;
